import React from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";
import { useStudyPlan } from "../../../../app/contexts/study.context";
import EditIcon from "@material-ui/icons/Edit";
import Label from "./label";
import moment from "moment";
import { SectionHeader } from "../../../../app/components";
import SeparateContainer from "../../../../app/components/separate.Container";
import OutlinedButton from "../../../../app/components/buttons/outlined";
import SideBySide from "../../../../app/components/sideBySide";

const PrimaryDetails = () => {
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const { studyPlan, canEditPlan } = useStudyPlan();

  const {
    studyPlanName,
    studyPlanDescr,
    croProjectStartDateMillis,
    finalProtocolStartDateMillis,
    scenarioStatus,
    studyPlanTypeDetail,
  } = studyPlan;

  const startDate = moment(croProjectStartDateMillis)
    .utc()
    .format("DD/MMM/YYYY");
  const protocolDate = moment(finalProtocolStartDateMillis)
    .utc()
    .format("DD/MMM/YYYY");
  const sections = [
    {
      items: [
        { label: "Study Plan Name", value: studyPlanName },
        { label: "Description", value: studyPlanDescr },
      ],
    },
    {
      items: [
        { label: "Status", value: scenarioStatus },
        { label: "Type", value: studyPlanTypeDetail },
      ],
    },
    {
      items: [
        {
          label: "CRO Start Date",
          value: startDate,
        },
        {
          label: "Protocol Date",
          value: protocolDate,
        },
      ],
    },
  ];
  return (
    <SeparateContainer>
      <SideBySide>
        <SectionHeader
          paddingBottom={false}
          marginBottom={false}
        >
          Study Details
        </SectionHeader>

        {canEditPlan && (
          <OutlinedButton
            style={{ marginBlock: "0.7em", marginInline: "1em" }}
            onClick={() =>
              navigate(`/ctpo/study-plans/${id}/${planId}#details`)
            }
          >
            <EditIcon style={{ marginRight: ".3em" }} /> Edit
          </OutlinedButton>
        )}
      </SideBySide>
      <div style={{ padding: "20px" }}>
        <Container>
          <Content>
            {sections.map((section, index) => (
              <div key={index}>
                {section.items.map(({ label, value }, idx) => (
                  <Label
                    key={idx}
                    label={label}
                    value={value}
                    color="var(--text-primary)"
                  />
                ))}
              </div>
            ))}
          </Content>
        </Container>
      </div>
    </SeparateContainer>
  );
};

export default PrimaryDetails;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  width: -webkit-fill-available;
  margin-top: 1em;
`;

const Content = styled.div`
  display: flex;
  width: 100%;

  > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1em;
  }

  > div:not(:last-child) {
    padding-right: 1.25rem;
  }
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: var(--surface-50);
  border-radius: 4px;
  margin-bottom: 3em;
`;
